import { PRESUPUESTADOR_CLEAR_BONIFICATION_TAKING_CARS } from './constants'

export function clearBonificacionUsados() {

    return (dispatch, getState) => {

        const { presupuestador } = getState()

        const entregaUsados = presupuestador.entregaUsados.map(usado => {
            usado.take_improvement_amount = 0
            usado.final_take_price =
                usado.updatedTakePrice || usado.original_price

            return usado
        })
        
        dispatch({
            type: PRESUPUESTADOR_CLEAR_BONIFICATION_TAKING_CARS,
            data: {
                entregaUsados
            }
        })
    }
}

export function reducer(state, action) {
    if (action.type === PRESUPUESTADOR_CLEAR_BONIFICATION_TAKING_CARS) {
        return {
            ...state,
            ...action.data
        }
    } else {
        return state
    }
}
